import React, { useState } from 'react';
import { CUSTOM_FIELD_TYPES_WITH_OPTIONS, filterColumns, getAllColumnOptions, groupColumns } from '../../helpers/collegeColumns';

function ColumnPicker({
  activeColumns,
  customColumns = [],
  onToggleColumn,
  onCreateCustomColumn,
  searchValue,
  onSearchChange,
  style,
}) {
  const [customFieldName, setCustomFieldName] = useState('');
  const [customFieldType, setCustomFieldType] = useState('text');
  const [customFieldLabels, setCustomFieldLabels] = useState('');
  const [customCreatorOpen, setCustomCreatorOpen] = useState(false);
  const visibleColumns = filterColumns(getAllColumnOptions(customColumns), searchValue);
  const groupedColumns = groupColumns(visibleColumns);
  const categories = Object.keys(groupedColumns);
  const canCreateCustomField = customFieldName.trim().length > 0;

  const handleCreateCustomField = (e) => {
    e.preventDefault();
    if (!canCreateCustomField || !onCreateCustomColumn) return;
    const labels = customFieldLabels.split(',').map((label) => label.trim()).filter(Boolean);
    onCreateCustomColumn(customFieldName, customFieldType, labels);
    setCustomFieldName('');
    setCustomFieldType('text');
    setCustomFieldLabels('');
    setCustomCreatorOpen(false);
  };

  return (
    <div className="column-picker-dropdown" data-testid="column-picker-dropdown" style={style}>
      <div className="column-picker-dropdown__header">
        <span>Columns</span>
        <span>{activeColumns.length} selected</span>
      </div>

      <div className="column-picker-search">
        <input
          type="text"
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search fields..."
          autoFocus
        />
      </div>

      <div className="column-picker-custom">
        <div className="column-picker-custom__title">Custom Fields</div>
        <button
          type="button"
          className="column-picker-custom__toggle"
          onClick={() => setCustomCreatorOpen(prev => !prev)}
          aria-expanded={customCreatorOpen}
        >
          <span aria-hidden="true">+</span>
          Create your own field
        </button>

        {customCreatorOpen && (
          <form className="column-picker-create" onSubmit={handleCreateCustomField}>
            <div className="column-picker-create__row">
              <input
                id="column-picker-create-input"
                type="text"
                value={customFieldName}
                onChange={(e) => setCustomFieldName(e.target.value)}
                placeholder="Essay status, Interview, Notes..."
                autoFocus
              />
              <select
                value={customFieldType}
                onChange={(e) => setCustomFieldType(e.target.value)}
                aria-label="Custom field type"
              >
                <option value="text">Text</option>
                <option value="link">Link</option>
                <option value="label">Labels</option>
                <option value="checkbox">Checkbox</option>
                <option value="dropdown">Dropdown</option>
                <option value="date">Date</option>
                <option value="number">Number</option>
              </select>
              <button type="submit" disabled={!canCreateCustomField}>
                Create
              </button>
            </div>
            {CUSTOM_FIELD_TYPES_WITH_OPTIONS.includes(customFieldType) && (
              <input
                className="column-picker-create__labels"
                type="text"
                value={customFieldLabels}
                onChange={(e) => setCustomFieldLabels(e.target.value)}
                placeholder="Option 1, Option 2, Option 3"
              />
            )}
          </form>
        )}
      </div>

      <div className="column-picker-groups">
        {categories.length === 0 ? (
          <div className="column-picker-empty">No matching fields</div>
        ) : (
          categories.map((category) => (
            <div className="column-picker-group" key={category}>
              <div className="column-picker-group__title">{category}</div>
              {groupedColumns[category].map((col) => (
                <label key={col.id} className="column-picker-option">
                  <input
                    type="checkbox"
                    className="column-picker-checkbox"
                    checked={activeColumns.includes(col.id)}
                    onChange={() => onToggleColumn(col.id)}
                  />
                  <span className="column-picker-option__label">{col.label}</span>
                </label>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default ColumnPicker;
